import gsap from "gsap";

import { Component } from "../extends";

export default () =>
	class ContactInfo extends Component() {
		mounted() {
			this.content =
				this.el.querySelectorAll(".c-contact-info__content") || [];
			this.circle = this.el.querySelector(
				".c-contact-info__circle .c-circle__fill"
			);
		}

		animations() {
			gsap.set(this.content, {
				y: "20%",
				opacity: 0,
			});

			gsap.set(this.circle, { scale: 0, transformOrigin: "50% 50%" });

			this.anim = gsap.timeline();

			this.anim.to(
				this.content,
				{
					y: 0,
					opacity: 1,
					ease: "sine.out",
					duration: 0.6,
					stagger: 0.15,
				},
				0.2
			);

			this.anim.to(
				this.circle,
				{
					scale: 1,
					ease: "back.out",
					duration: 1.05,
				},
				0.2
			);

			this.anim.seek(0);
			this.anim.play();
		}
	};
